"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalMetricReport = /** @class */ (function () {
    function GlobalMetricReport() {
        this.previousMetrics = {};
        this.currentMetrics = {};
    }
    return GlobalMetricReport;
}());
exports.default = GlobalMetricReport;
//# sourceMappingURL=GlobalMetricReport.js.map